// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.submit-container {
  width: 749px;
  height: 606px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  align-self: center;
  padding: 0 43px;
}
.submit-container .header, .submit-container .subheader {
  font-family: "Proxima Nova", sans-serif;
  margin: 0;
}
.submit-container .header {
  font-size: 40px;
  font-weight: 700;
  color: var(--secondary-color-1);
}
.submit-container .subheader {
  font-size: 25px;
  font-weight: 600;
  color: var(--secondary-color-2);
  text-align: center;
}
.submit-container .illus {
  height: 250px;
}
.submit-container .browse {
  width: 240px;
  padding: 23px 0;
  border-radius: 10px;
  background-color: #FEF4D2;
  color: var(--primary-color-1);
  font-family: "Roboto", sans-serif;
  font-size: 20px;
  font-weight: 700;
  text-align: center;
  transition: 0.2s ease-in-out;
  cursor: pointer;
}
.submit-container .browse:hover {
  opacity: 0.75;
}
.submit-container .contents {
  border-radius: 50px;
  background-color: white;
  padding: 30px;
  min-width: 800px;
  display: flex;
  flex-direction: column;
  box-shadow: 0px 10px 20px 0px rgba(0, 0, 0, 0.15);
  z-index: 2;
}
.submit-container .contents#showing-preview {
  position: absolute;
  box-shadow: none;
  top: -100%;
  z-index: 1;
}
.submit-container .contents#showing-preview .preview {
  margin-bottom: 30px;
  height: -moz-fit-content;
  height: fit-content;
}
.submit-container .contents .preview {
  width: 100%;
  height: 400px;
  border-radius: 20px;
  background-size: cover;
  margin-bottom: 30px;
}
.submit-container .contents .content-details {
  width: 100%;
}
.submit-container .contents .content-details .listing-details {
  display: flex;
  width: 100%;
}
.submit-container .contents .content-details .listing-details .listing-info {
  flex: 1 1;
}
.submit-container .contents .content-details .listing-details .listing-info .address, .submit-container .contents .content-details .listing-details .listing-info .listing, .submit-container .contents .content-details .listing-details .listing-info .title {
  font-family: "Proxima Nova", sans-serif;
  font-weight: 700;
  margin: 0;
}
.submit-container .contents .content-details .listing-details .listing-info .address {
  font-size: 20px;
  color: var(--secondary-color-5);
}
.submit-container .contents .content-details .listing-details .listing-info .title {
  font-size: 30px;
  color: var(--secondary-color-1);
}
.submit-container .contents .content-details .listing-details .listing-info .listing {
  font-size: 16px;
  color: var(--secondary-color-5);
}
.submit-container .contents .content-details .listing-details .listing-agent {
  display: flex;
  align-items: center;
  padding: 15px 30px;
  justify-content: center;
  align-items: center;
  border-radius: 10px;
  height: -moz-fit-content;
  height: fit-content;
  background-color: var(--secondary-color-6);
}
.submit-container .contents .content-details .listing-details .listing-agent > span {
  color: var(--secondary-color-1);
  font-family: "Proxima Nova", sans-serif;
  font-size: 16px;
  font-weight: 700;
}
.submit-container .contents .content-details .listing-details .listing-agent > img {
  width: 30px;
  height: 30px;
  object-fit: cover;
  border-radius: 5px;
  margin-right: 10px;
}
.submit-container .contents .content-details .info-container {
  display: flex;
  justify-content: space-between;
  border-radius: 10px;
  background: var(--secondary-color-6);
  padding: 30px;
}
.submit-container .contents .content-details .info-container .details, .submit-container .contents .content-details .info-container .time {
  display: flex;
  flex-direction: column;
}
.submit-container .contents .content-details .info-container .details {
  font-family: "Proxima Nova", sans-serif;
  color: var(--primary-color-1);
}
.submit-container .contents .content-details .info-container .details > div {
  display: flex;
}
.submit-container .contents .content-details .info-container .details > div > img {
  width: 50px;
  height: 50px;
  object-fit: cover;
  border-radius: 5px;
  margin-right: 10px;
}
.submit-container .contents .content-details .info-container .details > div .content .buyer {
  font-size: 24px;
  font-weight: 700;
  margin: 0;
  color: var(--secondary-color-1);
}
.submit-container .contents .content-details .info-container .details > div .content .email {
  font-size: 16px;
  font-weight: 500;
  margin: 0;
  color: var(--secondary-color-5);
}
.submit-container .contents .content-details .info-container .details .showing {
  flex-direction: column;
  font-size: 20px;
}
.submit-container .contents .content-details .info-container .details .showing .date {
  font-size: 20px;
  font-weight: 700;
  margin: 0;
  color: var(--secondary-color-1);
  margin-bottom: 13px;
}
.submit-container .contents .content-details .info-container .details .showing .address {
  font-weight: 600;
  margin: 0;
  color: var(--secondary-color-5);
}
.submit-container .contents .content-details .info-container .time {
  justify-content: space-between;
  text-align: right;
  font-family: "Proxima Nova", sans-serif;
}
.submit-container .contents .content-details .info-container .time .duration {
  font-size: 24px;
  font-weight: 700;
  margin: 0;
  color: var(--secondary-color-1);
}
.submit-container .contents .content-details .info-container .time .specific {
  color: var(--secondary-color-5);
  font-size: 20px;
  font-weight: 600;
  margin: 0;
}
.submit-container .contents .content-details .agent {
  font-family: "Proxima Nova", sans-serif;
  font-size: 21px;
  font-weight: 700;
  margin: 0;
  margin-bottom: 5px;
  color: var(--secondary-color-1);
}
.submit-container .contents .content-details .buyer-agent-info {
  display: flex;
  flex-wrap: wrap;
}
.submit-container .contents .content-details .buyer-agent-info > div {
  flex: 50% 1;
  display: flex;
  align-items: center;
  margin-bottom: 35px;
  font-size: 16px;
  font-weight: 600;
  color: var(--secondary-color-5);
  font-family: "Proxima Nova", sans-serif;
}
.submit-container .contents .content-details .buyer-agent-info > div > svg {
  margin-right: 15px;
}
.submit-container .contents .content-details .compensation {
  display: flex;
  align-items: center;
}
.submit-container .contents .content-details .compensation > span {
  color: var(--primary-color-1);
  font-weight: 700;
}
.submit-container .contents .add {
  font-weight: 700 !important;
  display: flex;
  align-items: center;
  padding: 0 10px;
}
.submit-container .contents .change {
  font-weight: 700 !important;
  display: flex;
  align-items: center;
  padding: 0 10px;
  background: white;
  color: var(--secondary-color-5);
  border: 1px solid var(--secondary-color-5);
}
.submit-container .contents .change:hover {
  opacity: 0.75;
}

@media (min-width: 481px) and (max-width: 767px), (min-width: 320px) and (max-width: 480px) {
  .submit-container {
    width: 100%;
    height: auto;
    margin: 0 20px;
    padding: 40px;
    text-align: center;
  }
  .submit-container .header {
    font-size: 32px;
  }
  .submit-container .subheader {
    font-size: 18px;
  }
  .submit-container .browse {
    height: 40px;
    font-size: 16px;
    padding: 10px 0;
    border-radius: 5px;
  }
}
@media (min-width: 768px) and (max-width: 1024px), (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
  .submit-container {
    width: 100%;
    height: auto;
    margin: 0 20px;
    padding: 40px;
    text-align: center;
  }
  .submit-container .header {
    font-size: 32px;
  }
  .submit-container .subheader {
    font-size: 18px;
  }
  .submit-container .browse {
    height: 40px;
    font-size: 16px;
    padding: 10px 0;
    border-radius: 5px;
  }
}`, "",{"version":3,"sources":["webpack://./src/routes/Response/modules/RequestSubmitted/requestSubmitted.scss","webpack://./src/assets/styles/_mixins.scss"],"names":[],"mappings":"AAEA;EACI,YAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,eAAA;AADJ;AAEI;EACI,uCAAA;EACA,SAAA;AAAR;AAEI;EACI,eAAA;EACA,gBAAA;EACA,+BAAA;AAAR;AAEI;EACI,eAAA;EACA,gBAAA;EACA,+BAAA;EACA,kBAAA;AAAR;AAEI;EACI,aAAA;AAAR;AAEI;EACI,YAAA;EACA,eAAA;EACA,mBAAA;EACA,yBAAA;EACA,6BAAA;EACA,iCAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,4BAAA;EACA,eAAA;AAAR;AACQ;EACI,aAAA;AACZ;AAEI;EACI,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,iDAAA;EACA,UAAA;AAAR;AACQ;EACI,kBAAA;EACA,gBAAA;EAEA,UAAA;EACA,UAAA;AAAZ;AACY;EACI,mBAAA;EACA,wBAAA;EAAA,mBAAA;AAChB;AAEQ;EACI,WAAA;EACA,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,mBAAA;AAAZ;AAEQ;EACI,WAAA;AAAZ;AACY;EACI,aAAA;EACA,WAAA;AAChB;AAAgB;EACI,SAAA;AAEpB;AADoB;EACI,uCAAA;EACA,gBAAA;EACA,SAAA;AAGxB;AADoB;EACI,eAAA;EACA,+BAAA;AAGxB;AADoB;EACI,eAAA;EACA,+BAAA;AAGxB;AADoB;EACI,eAAA;EACA,+BAAA;AAGxB;AAAgB;EACI,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,wBAAA;EAAA,mBAAA;EACA,0CAAA;AAEpB;AADoB;EACI,+BAAA;EACA,uCAAA;EACA,eAAA;EACA,gBAAA;AAGxB;AADoB;EACI,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;AAGxB;AACY;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,oCAAA;EACA,aAAA;AAChB;AAAgB;EACI,aAAA;EACA,sBAAA;AAEpB;AAAgB;EACI,uCAAA;EACA,6BAAA;AAEpB;AADoB;EACI,aAAA;AAGxB;AAFwB;EACI,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;AAI5B;AAD4B;EACI,eAAA;EACA,gBAAA;EACA,SAAA;EACA,+BAAA;AAGhC;AAD4B;EACI,eAAA;EACA,gBAAA;EACA,SAAA;EACA,+BAAA;AAGhC;AACoB;EACI,sBAAA;EACA,eAAA;AACxB;AAAwB;EACI,eAAA;EACA,gBAAA;EACA,SAAA;EACA,+BAAA;EACA,mBAAA;AAE5B;AAAwB;EACI,gBAAA;EACA,SAAA;EACA,+BAAA;AAE5B;AAEgB;EACI,8BAAA;EACA,iBAAA;EACA,uCAAA;AAApB;AACoB;EACI,eAAA;EACA,gBAAA;EACA,SAAA;EACA,+BAAA;AACxB;AACoB;EACI,+BAAA;EACA,eAAA;EACA,gBAAA;EACA,SAAA;AACxB;AAIY;EACI,uCAAA;EACA,eAAA;EACA,gBAAA;EACA,SAAA;EACA,kBAAA;EACA,+BAAA;AAFhB;AAIY;EACI,aAAA;EACA,eAAA;AAFhB;AAGgB;EACI,WAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,+BAAA;EACA,uCAAA;AADpB;AAEoB;EACI,kBAAA;AAAxB;AAIY;EACI,aAAA;EACA,mBAAA;AAFhB;AAGgB;EACI,6BAAA;EACA,gBAAA;AADpB;AAKQ;EACI,2BAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;AAHZ;AAKQ;EACI,2BAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,+BAAA;EACA,0CAAA;AAHZ;AAIY;EACI,aAAA;AAFhB;;AC9OY;EDuPR;IACI,WAAA;IACA,YAAA;IACA,cAAA;IACA,aAAA;IACA,kBAAA;EALN;EAMM;IACI,eAAA;EAJV;EAMM;IACI,eAAA;EAJV;EAMM;IACI,YAAA;IACA,eAAA;IACA,eAAA;IACA,kBAAA;EAJV;AACF;AC7PY;EDgPR;IACI,WAAA;IACA,YAAA;IACA,cAAA;IACA,aAAA;IACA,kBAAA;EAgBN;EAfM;IACI,eAAA;EAiBV;EAfM;IACI,eAAA;EAiBV;EAfM;IACI,YAAA;IACA,eAAA;IACA,eAAA;IACA,kBAAA;EAiBV;AACF","sourcesContent":["@import 'assets/styles/_mixins.scss';\r\n\r\n.submit-container {\r\n    width: 749px;\r\n    height: 606px;\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    justify-content: center;\r\n    align-self: center;\r\n    padding: 0 43px;\r\n    .header, .subheader {\r\n        font-family: 'Proxima Nova', sans-serif;\r\n        margin: 0;\r\n    }\r\n    .header {\r\n        font-size: 40px;\r\n        font-weight: 700;\r\n        color: var(--secondary-color-1);\r\n    }\r\n    .subheader {\r\n        font-size: 25px;\r\n        font-weight: 600;\r\n        color: var(--secondary-color-2);\r\n        text-align: center;\r\n    }\r\n    .illus {\r\n        height: 250px;\r\n    }\r\n    .browse {\r\n        width: 240px;\r\n        padding: 23px 0;\r\n        border-radius: 10px;\r\n        background-color: #FEF4D2;\r\n        color: var(--primary-color-1);\r\n        font-family: \"Roboto\", sans-serif;\r\n        font-size: 20px;\r\n        font-weight: 700;\r\n        text-align: center;\r\n        transition: .2s ease-in-out;\r\n        cursor: pointer;\r\n        &:hover {\r\n            opacity: .75;\r\n        }\r\n    }\r\n    .contents {\r\n        border-radius: 50px;\r\n        background-color: white;\r\n        padding: 30px;\r\n        min-width: 800px;\r\n        display: flex;\r\n        flex-direction: column;\r\n        box-shadow: 0px 10px 20px 0px rgba(0, 0, 0, 0.15);\r\n        z-index: 2;\r\n        &#showing-preview {\r\n            position: absolute;\r\n            box-shadow: none;\r\n            // border: 1px solid var(--secondary-color-4);\r\n            top: -100%;\r\n            z-index: 1;\r\n            .preview {\r\n                margin-bottom: 30px;\r\n                height: fit-content;\r\n            }\r\n        }\r\n        .preview {\r\n            width: 100%;\r\n            height: 400px;\r\n            border-radius: 20px;\r\n            background-size: cover;\r\n            margin-bottom: 30px;\r\n        }\r\n        .content-details {\r\n            width: 100%;\r\n            .listing-details {\r\n                display: flex;\r\n                width: 100%;\r\n                .listing-info {\r\n                    flex: 1;\r\n                    .address, .listing, .title {\r\n                        font-family: 'Proxima Nova', sans-serif;\r\n                        font-weight: 700;\r\n                        margin: 0;\r\n                    }\r\n                    .address {\r\n                        font-size: 20px;\r\n                        color: var(--secondary-color-5);\r\n                    }\r\n                    .title {\r\n                        font-size: 30px;\r\n                        color: var(--secondary-color-1);\r\n                    }\r\n                    .listing {\r\n                        font-size: 16px;\r\n                        color: var(--secondary-color-5);\r\n                    }\r\n                }\r\n                .listing-agent {\r\n                    display: flex;\r\n                    align-items: center;\r\n                    padding: 15px 30px;\r\n                    justify-content: center;\r\n                    align-items: center;\r\n                    border-radius: 10px;\r\n                    height: fit-content;\r\n                    background-color: var(--secondary-color-6);\r\n                    > span {\r\n                        color: var(--secondary-color-1);\r\n                        font-family: 'Proxima Nova', sans-serif;\r\n                        font-size: 16px;\r\n                        font-weight: 700;\r\n                    }\r\n                    > img {\r\n                        width: 30px;\r\n                        height: 30px;\r\n                        object-fit: cover;\r\n                        border-radius: 5px;\r\n                        margin-right: 10px;\r\n                    }\r\n                }\r\n            }\r\n            .info-container {\r\n                display: flex;\r\n                justify-content: space-between;\r\n                border-radius: 10px;\r\n                background: var(--secondary-color-6);\r\n                padding: 30px;\r\n                .details, .time {\r\n                    display: flex;\r\n                    flex-direction: column;\r\n                }\r\n                .details {\r\n                    font-family: 'Proxima Nova', sans-serif;\r\n                    color: var(--primary-color-1);\r\n                    > div {\r\n                        display: flex;\r\n                        > img {\r\n                            width: 50px;\r\n                            height: 50px;\r\n                            object-fit: cover;\r\n                            border-radius: 5px;\r\n                            margin-right: 10px;\r\n                        }\r\n                        .content {\r\n                            .buyer {\r\n                                font-size: 24px;\r\n                                font-weight: 700;\r\n                                margin: 0;\r\n                                color: var(--secondary-color-1);\r\n                            }\r\n                            .email {\r\n                                font-size: 16px;\r\n                                font-weight: 500;\r\n                                margin: 0;\r\n                                color: var(--secondary-color-5);\r\n                            }\r\n                        }\r\n                    }\r\n                    .showing {\r\n                        flex-direction: column;\r\n                        font-size: 20px;\r\n                        .date {\r\n                            font-size: 20px;\r\n                            font-weight: 700;\r\n                            margin: 0;\r\n                            color: var(--secondary-color-1);\r\n                            margin-bottom: 13px;\r\n                        }\r\n                        .address {\r\n                            font-weight: 600;\r\n                            margin: 0;\r\n                            color: var(--secondary-color-5);\r\n                        }\r\n                    }\r\n                }\r\n                .time {\r\n                    justify-content: space-between;\r\n                    text-align: right;\r\n                    font-family: 'Proxima Nova', sans-serif;\r\n                    .duration {\r\n                        font-size: 24px;\r\n                        font-weight: 700;\r\n                        margin: 0;\r\n                        color: var(--secondary-color-1);\r\n                    }\r\n                    .specific {\r\n                        color: var(--secondary-color-5);\r\n                        font-size: 20px;\r\n                        font-weight: 600;\r\n                        margin: 0;\r\n                    }\r\n                }\r\n            }\r\n\r\n            .agent {\r\n                font-family: 'Proxima Nova', sans-serif;\r\n                font-size: 21px;\r\n                font-weight: 700;\r\n                margin: 0;\r\n                margin-bottom: 5px;\r\n                color: var(--secondary-color-1);\r\n            }\r\n            .buyer-agent-info {\r\n                display: flex;\r\n                flex-wrap: wrap;\r\n                > div {\r\n                    flex: 50%;\r\n                    display: flex;\r\n                    align-items: center;\r\n                    margin-bottom: 35px;\r\n                    font-size: 16px;\r\n                    font-weight: 600;\r\n                    color: var(--secondary-color-5);\r\n                    font-family: 'Proxima Nova', sans-serif;\r\n                    > svg {\r\n                        margin-right: 15px;\r\n                    }\r\n                }\r\n            }\r\n            .compensation {\r\n                display: flex;\r\n                align-items: center;\r\n                > span {\r\n                    color: var(--primary-color-1);\r\n                    font-weight: 700;\r\n                }\r\n            }\r\n        }\r\n        .add {\r\n            font-weight: 700 !important;\r\n            display: flex;\r\n            align-items: center;\r\n            padding: 0 10px;\r\n        }\r\n        .change {\r\n            font-weight: 700 !important;\r\n            display: flex;\r\n            align-items: center;\r\n            padding: 0 10px;\r\n            background: white;\r\n            color: var(--secondary-color-5);\r\n            border: 1px solid var(--secondary-color-5);\r\n            &:hover {\r\n                opacity: .75;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n@include media(mobile, tablet) {\r\n    .submit-container {\r\n        width: 100%;\r\n        height: auto;\r\n        margin: 0 20px;\r\n        padding: 40px;\r\n        text-align: center;\r\n        .header {\r\n            font-size: 32px;\r\n        }\r\n        .subheader {\r\n            font-size: 18px;\r\n        }\r\n        .browse {\r\n            height: 40px;\r\n            font-size: 16px;\r\n            padding: 10px 0;\r\n            border-radius: 5px;\r\n        }\r\n    }\r\n}","@mixin media($keys...) {\r\n    @each $key in $keys {\r\n        @if ($key==mobile) {\r\n            @media (min-width: 481px) and (max-width: 767px),\r\n            (min-width: 320px) and (max-width: 480px) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==tablet) {\r\n            @media (min-width: 768px) and (max-width: 1024px),\r\n            (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==nitty-gritt) {\r\n            @media (width: 1024px) and (max-height: 833px) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==small-desktop) {\r\n            @media (max-width: 1440px) and (max-height: 833px) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==desktop) {\r\n            @media (min-width: 1024px) and (max-width: 1440px) {\r\n                @content;\r\n            }\r\n        }\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
